{
  "type": "object",
  "name": "voucher",
  "class": "py-4 text-sm",
  "definitions": [
    {
      "type": "text",
      "text": "Belegdaten",
      "class": "soft-overline border-b border-solid border-spacing-2"
    },
    {
      "type": "string",
      "title": "Belegart",
      "name": "detail.belegartKopferw",
      "class": "flex justify-between w-full text-right border-b border-solid pt-1 pb-1 whitespace-nowrap",
      "titleClass": "mr-8"
    },
    {
      "type": "string",
      "title": "StreckenNr.",
      "name": "detail.belegnummer",
      "class": "flex justify-between w-full text-right border-b border-solid pt-1 pb-1",
      "titleClass": "mr-8"
    },
    {
      "type": "date",
      "title": "Belegdatum",
      "name": "detail.belegdatum",
      "class": "flex justify-between w-full text-right border-b border-solid pt-1 pb-1",
      "titleClass": "mr-8"
    },
    {
      "type": "entity",
      "title": "Lieferant",
      "name": "detail.ktostamm",
      "endpoint": "",
      "format": "{{number}} - {{name}}",
      "class": "flex justify-between w-full text-right border-b border-solid pt-1 pb-1",
      "titleClass": "mr-8"
    },
    {
      "type": "currency",
      "title": "Nettobetrag",
      "name": "detail.nettoBetrag",
      "code": "EUR",
      "class": "flex justify-between w-full text-right border-b border-solid pt-1 pb-1",
      "titleClass": "mr-8"
    },
    {
      "type": "currency",
      "title": "Bruttobetrag",
      "name": "detail.bruttoBetrag",
      "code": "EUR",
      "class": "flex justify-between w-full text-right border-b border-solid pt-1 pb-1",
      "titleClass": "mr-8"
    },
    {
      "type": "date",
      "title": "Fälligkeit",
      "name": "detail.faelligkeit",
      "class": "flex justify-between w-full text-right border-b border-solid pt-1 pb-1",
      "titleClass": "mr-8"
    },
    {
      "type": "string",
      "title": "Objekt (Projektnummer in TR/SR)",
      "name": "detail.objekt",
      "format": "{{objekt}} - {{bezeichnung}}",
      "class": "flex justify-between w-full text-right border-b border-solid pt-1 pb-1",
      "titleClass": "mr-8"
    },
    {
      "type": "entity",
      "title": "Baustelle",
      "name": "detail.ktostamm_lief",
      "format": "{{number}} - {{name}}",
      "class": "flex justify-between w-full text-right border-b border-solid pt-1 pb-1",
      "titleClass": "mr-8"
    }
  ]
}
